export default __webpack_public_path__ + "static/media/chinmoy.13b9b79e.png";